"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullMath = void 0;
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const ZERO = 0n;
const ONE = 1n;
let FullMath = exports.FullMath = /*#__PURE__*/function () {
  function FullMath() {
    _classCallCheck(this, FullMath);
  }
  return _createClass(FullMath, null, [{
    key: "mulDivRoundingUp",
    value: function mulDivRoundingUp(a, b, denominator) {
      // Check for division by zero
      if (denominator === ZERO) {
        throw new Error("Division by zero");
      }

      // Early return for zero inputs
      if (a === ZERO || b === ZERO) {
        return ZERO;
      }

      // Early return if denominator is one
      if (denominator === ONE) {
        return a * b;
      }

      // Calculate product, quotient, and remainder
      const product = a * b;
      const quotient = product / denominator;
      const remainder = product % denominator;

      // Round up if there’s a non-zero remainder
      if (remainder !== ZERO) {
        return quotient + ONE;
      }
      return quotient;
    }
  }]);
}();